import{s as y}from"./storefront-C7VK9Ron.js";import"./constants-YggLgYDY.js";const getGroupLetter=e=>{const t=e.replace(/^[^a-zA-Z0-9]+/,"").charAt(0).toUpperCase();return/[0-9]/.test(t)?"0-9":t};const hasStock=async h=>{try{const r=await fetch(`/collections/${h}/products.json?limit=10`);if(!r.ok)return false;const d=await r.json();return(d.products||[]).some(p=>(p.variants||[]).some(v=>v.available===true))}catch{return false}};const p=async a=>{const candidates=a.data.metaobjects.edges.map(({node:e})=>{const{id:o,handle:s,fields:t}=e;const l=t.find(r=>r.key==="name")?.value;if(!l)return null;const c=t.find(r=>r.key==="collection");if(!c?.reference?.handle)return null;return{id:o,handle:s,name:l,collection:c.reference}}).filter(Boolean);const stockChecks=await Promise.all(candidates.map(b=>hasStock(b.collection.handle)));const validated=candidates.filter((_,i)=>stockChecks[i]);const n=new Map;validated.forEach(b=>{const d=getGroupLetter(b.name);const m=n.get(d)||[];m.push(b);n.set(d,m)});const i=Array.from(n.keys()).sort((a,b)=>a==="0-9"?-1:b==="0-9"?1:a.localeCompare(b));const u=document.querySelector(".letter-list");u&&(u.innerHTML=i.map(e=>`<li class="letter-list-item"><a href="#${e.toLowerCase().replace("-","")}">${e}</a></li>`).join(""));const f=document.querySelector(".brands-list");f&&(f.innerHTML=i.map(e=>{const o=n.get(e).sort((s,t)=>s.name.localeCompare(t.name));return`
          <li id="${e.toLowerCase().replace("-","")}">
            <div class="brands-item"><strong>${e}</strong></div>
            <ul class="brands-list">
              ${o.map(({collection:s,name:t})=>`
                    <li class="brands-item">
                      ${s?`<a href="/collections/${s.handle}">${t}</a>`:t}
                    </li>
                  `).join("")}
            </ul>
          </li>
        `}).join(""))};const b=async()=>{y(`
query {
  metaobjects(first: 250, type: "brand") {
    edges {
      node {
        id
        handle
        fields {
          key
          value
          reference {
            ... on Collection {
              id
              handle
            }
          }
        }
      }
    }
  }
}
`,p)};b();